import React from 'react';
import {styled} from '@netx/core-components/Theme';
import {SystemView, type SystemViewProps} from '../SystemView';

export const TableViewRoot = styled(SystemView)(({theme}) => ({
	display: 'flex',
	flex: '1 1 auto',
	flexDirection: 'column',
	overflow: 'hidden',
	minHeight: 0,
}));

export interface TableViewProps extends SystemViewProps {}

export const TableViewPrimitive = (
	props: TableViewProps,
	ref: React.ForwardedRef<HTMLDivElement>,
) => {
	return <TableViewRoot ref={ref} {...props} />;
};

export const TableView = React.forwardRef<HTMLDivElement, TableViewProps>(
	TableViewPrimitive,
);

export default TableView;
